export enum EmploymentType {
	FullTime,
	PartTime,
}
